/**
 * 新建短信模版
 * Create by liaokai on 2020-04-23 18:13:11
 */
import {toPost} from "../../http-utils";
import {ITagItem} from "../../../../routes/index/meeting-list/meeting/menu/sms-multi-send/sms-template/editor/sms-template-editor";

export const smsTemplateStore = toPost<
    {
        meetid : number,
        title : string,
        text : ITagItem[]
    },
    {

    }
>("/merchant/Lcm/smsTemplateStore");

